import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import { useSalesContext } from "../../SalesContext";
import { API_BASE_URL } from "../../../config/config";
interface CategoryProgressProps {
  categories: {
    name: string;
    current: number;
    total: number;
    percentage: number;
    color?: string;
  }[];
  isLimited: boolean;
  viewType: "category" | "speciality" | "frequency";
}

const CategoryProgress: React.FC<CategoryProgressProps> = ({
  categories,
  isLimited,
  viewType,
}) => {
  const { setShowtable, setKpiData, newFilterdata, setLoading } =
    useSalesContext();

  const handleProgressBarClick = async (
    categoryName: string,
    categoryCurrent,
    categoryTotal
  ) => {
    try {
      setLoading(true);
      setShowtable(true);

      const apiEndpoint = isLimited
        ? `${API_BASE_URL}MyPerformance/MissedCallsPartyDetails`
        : `${API_BASE_URL}MyPerformance/CompliancePartyDetails`;

      const keyMap = {
        category: "Category",
        speciality: "Speciality",
        frequency: "Frequency",
      };
      const payloadKey = keyMap[viewType];

      const payload = {
        [payloadKey]: categoryName,
        ...newFilterdata,
      };
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const Tabledata = await response.json();

      setLoading(false);
      setKpiData({
        Tabledata,
        categoryName,
        categoryCurrent,
        categoryTotal,
        isLimited,
      });
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setLoading(false);
    }
  };
  const sortedCategories = [...categories].sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  return (
    <Box sx={{ pt: 2, maxHeight: "250px", overflow: "auto" }}>
      {sortedCategories.map((category, index) => {
        const progress = (category.current / category.total) * 100 || 0;

        const barColor = index % 2 === 0 ? "#F2C737" : "#5593F2";

        return (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Box sx={{ flex: 1, mx: 2 }}>
              <Typography
                variant="body1"
                sx={{ width: 200, fontWeight: "bold" }}
              >
                {category.name}
              </Typography>
              <Box sx={{ position: "relative" }}>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{
                    position: "absolute",
                    right: 0,
                    top: -20,
                  }}
                >
                  ({category.percentage}%)
                </Typography>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  {category.current}/{category.total}
                </Typography>
                <LinearProgress
                  variant="determinate"
                  value={progress}
                  onClick={() =>
                    handleProgressBarClick(
                      category.name,
                      category.current,
                      category.total
                    )
                  }
                  sx={{
                    height: 8,
                    borderRadius: 4,
                    backgroundColor: "#e0e0e0",
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: barColor,
                    },
                    "&:hover": {
                      cursor: "pointer",
                    },
                  }}
                />
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default CategoryProgress;
